// Layout 未在本文件使用，移除以避免与布局页形成循环依赖
const child =  [
  {
    path: '',
    name: '管理',
    icon: 'el-icon-full-screen',
    component: { render: c => c("router-view") },
    redirect: '/index',
    children: [
      {   name: '详情页', path: '/index', component: () => import( /* webpackChunkName: "page" */ '@/views/desk/index')}
    ]
  },

];

export default child 



// WEBPACK FOOTER //
// ./src/router/views/index.js